import { atom } from 'jotai';
import { subjectIdFromName } from '@utils/helpers/SubjectParser';

export const activeSubjectSlug = atom('');
export const activeSubjectId = atom(get =>
  subjectIdFromName(get(activeSubjectSlug)),
);
export const activeSubjectExpiredAtom = atom<null | boolean>(null);
